import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config';

const { baseAPI: baseURL } = config;

const getCsrfToken = () => {
    let csrfToken = null;
    try {
        const meta = JSON.parse(localStorage.meta);
        csrfToken = meta.csrfToken;
    } catch (e) {}
    if (!csrfToken) {
        csrfToken = localStorage.csrf;
    }

    return csrfToken;
};

const getAuthorizationToken = () => {
    return localStorage.getItem('auth0Token');
};

export const getHTTPHeaders = (extraHeaders = {}) => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-T-CSRF': getCsrfToken(),
        Authorization: `Bearer ${getAuthorizationToken()}`,
        'X-CHEQ-LOCATION': 'TBD',
        ...extraHeaders,
    };
};

const instance = axios.create({
    baseURL,
    withCredentials: true,
});

instance.interceptors.request.use((config) => {
    config.headers = getHTTPHeaders();
    return config;
});

instance.interceptors.response.use(
    (response) => {
        // Non-fatal server warning on a 2xx (body, not header — survives CORS): surface, don't block.
        const warning = response?.data?.warning;
        if (warning) {
            toast.warning(warning);
        }
        return response;
    },
    (error) => {
        return Promise.reject(error.response.data);
    },
);

export default instance;
